import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../features/AppState";
import { removeFetcherObjects } from "../../../../features/fetcherSettingsSlice";
import { setDisplayErrorSnackBar } from "../../../../features/userSlice";

interface Props {
  open: boolean;
  objectId: string;
  onClose: () => void;
}

/**
 * Deleting a system-default row changes what every collection without a
 * narrower value falls back to, so the warning differs from the one for an
 * already-unreachable row.
 */
const DeleteDevObjectModal = ({ open, objectId, onClose }: Props) => {
  const dispatch = useDispatch();
  const { objects } = useSelector((state: AppState) => state.fetcherSettings);
  const object = objects.find((row) => row.id === objectId);

  if (!object) return null;

  const isSystemDefault = object.raw === "system-default";

  const handleDelete = () => {
    // TODO: DELETE /aladdin_api/v1/data_collection/fetcher/objects/<id>
    dispatch(removeFetcherObjects([object.id]));
    dispatch(
      setDisplayErrorSnackBar({ message: "Row removed.", type: "success" }),
    );
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: "520px", maxWidth: "94vw" } }}
    >
      <DialogTitle sx={{ pb: 0.5 }}>Delete row?</DialogTitle>
      <Typography
        className="fetcher-mono"
        variant="body2"
        sx={{ px: 3, pb: 1.5, color: "#00000099" }}
      >
        {object.raw} · {object.k}
      </Typography>
      <Divider />
      <DialogContent sx={{ px: 3, py: 2 }}>
        <Alert severity={isSystemDefault ? "error" : "warning"}>
          {isSystemDefault
            ? `Every collection with no narrower value for ${object.k} falls back to whatever the collector hard-codes. Confirm with R&D.`
            : "This row is already unreachable, so deleting it changes no behaviour."}
        </Alert>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button color="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" color="error" onClick={handleDelete}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDevObjectModal;
